import { render } from "./DatatableDetails.vue?vue&type=template&id=2a19fa5b"
import script from "./DatatableDetails.vue?vue&type=script&lang=js"
export * from "./DatatableDetails.vue?vue&type=script&lang=js"
script.render = render

export default script